import React from 'react'
import "./contain.css"

const contain = (props) => {
  return (
    <div>{props.children}
    </div>
  )
}

export default contain